const txt = 'J’ai appris le piano lorsque j’avais 5 ans. J’adore particulièrement jouer du blues, du jazz et du pop et il m’arrive encore (très) souvent de pianoter plusieurs heures par semaine pour me détendre!';

export default txt;
